import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { NotificationService } from "ng/src/app/notifications/notification.service";
import { SystemNotificationService } from "ng/src/app/notifications/system-notification.service";
import { SystemNotification, Notification } from "ng/src/app/notifications/notification.model";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

type NotificationWithLogs = Notification.Projections.WithLogName;

@Component({
	selector: 'dual-notification-container',
	template: `
		<p-tabView *ngIf="hasSystemNotifications else templateUserNotifications" [activeIndex]="currentIndex" (activeIndexChange)="activeIndexChanged($event)">
			<p-tabPanel>
				<ng-template pTemplate="header">
					<div class="p-d-flex p-jc-center p-ai-center">
                        <span class="p-mr-2">User{{!hasSystemNotifications ? ' notifications' : ''}}</span>
						<p-badge *ngIf="userNotificationCount" severity="danger" [value]="userNotificationCount.toString()"></p-badge>
					</div>
				</ng-template>
				<ng-container *ngTemplateOutlet="templateUserNotifications"></ng-container>
			</p-tabPanel>
			<p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="p-d-flex p-jc-center p-ai-center">
                        <span class="p-mr-2">System</span>
                        <p-badge *ngIf="systemNotificationCount" severity="danger" [value]="systemNotificationCount.toString()"></p-badge>
                    </div>
                </ng-template>
				<system-notification-list (onNotificationSelected)="onSelected($event)"></system-notification-list>
			</p-tabPanel>
		</p-tabView>
		
		<ng-template #templateUserNotifications>
            <notification-list (onNotificationSelected)="onSelected($event)"></notification-list>
		</ng-template>
	`,
	styles: [
		'::ng-deep .p-tabview .p-tabview-panels { padding: 0 }',
		'::ng-deep .p-tabview-nav > li { width: 100% }',
		'::ng-deep a.p-tabview-nav-link { display: flex; justify-content: center }'
	]
})
export class DualNotificationContainerComponent implements OnInit, OnDestroy {
	
	@Input()
	set tab(val: 'user' | 'system') {
		this.currentIndex = val === 'user' ? 0 : 1;
	}
	
	@Output()
	tabChange = new EventEmitter<'user' | 'system'>();
	
	@Output()
	onSystemNotificationSelected = new EventEmitter<SystemNotification>();
	
	@Output()
	onNotificationSelected = new EventEmitter<NotificationWithLogs>();
	
	hasSystemNotifications = false;
	
	currentIndex = 0;
	
	
	private readonly destroySubject = new Subject();
	readonly onDestroy$ = this.destroySubject.asObservable();
	
	constructor(
		private notificationService: NotificationService,
		private systemNotificationService: SystemNotificationService
	) {}
	
	ngOnInit(): void {
		this.systemNotificationService.getPoll()
			.pipe(
				takeUntil(this.onDestroy$)
			)
			.subscribe(n => {
				if (Array.isArray(n)) {
					this.hasSystemNotifications = n.length > 0;
				}
			})
	}
	
	ngOnDestroy(): void {
		this.destroySubject.next();
	}
	
	get userNotificationCount() {
		return this.notificationService.unreadCount;
	}
	
	get systemNotificationCount() {
		return this.systemNotificationService.getUnreadCount();
	}
	
	activeIndexChanged(index: number) {
		this.currentIndex = index;
		this.tabChange.emit(index === 0 ? 'user' : 'system');
	}
	
	onSelected(val: NotificationWithLogs | SystemNotification | undefined) {
		if (!val) {
			return;
		}
		else if ('title' in val) {
			this.onSystemNotificationSelected.emit(val);
		}
		else if ('logId' in val) {
			this.onNotificationSelected.emit(val);
		}
	}
}